/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the CostiRicaviMeseAnnoDto interface.
 */
export function instanceOfCostiRicaviMeseAnnoDto(value) {
    return true;
}
export function CostiRicaviMeseAnnoDtoFromJSON(json) {
    return CostiRicaviMeseAnnoDtoFromJSONTyped(json, false);
}
export function CostiRicaviMeseAnnoDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'year': json['year'] == null ? undefined : json['year'],
        'month': json['month'] == null ? undefined : json['month'],
        'actualOtherCosts': json['actualOtherCosts'] == null ? undefined : json['actualOtherCosts'],
        'actualRevenue': json['actualRevenue'] == null ? undefined : json['actualRevenue'],
        'revenueProgressPercentage': json['revenueProgressPercentage'] == null ? undefined : json['revenueProgressPercentage'],
    };
}
export function CostiRicaviMeseAnnoDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'year': value['year'],
        'month': value['month'],
        'actualOtherCosts': value['actualOtherCosts'],
        'actualRevenue': value['actualRevenue'],
        'revenueProgressPercentage': value['revenueProgressPercentage'],
    };
}
